/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CollectionActivityWithoutTracks } from './CollectionActivityWithoutTracks';
import {
    CollectionActivityWithoutTracksFromJSON,
    CollectionActivityWithoutTracksFromJSONTyped,
    CollectionActivityWithoutTracksToJSON,
} from './CollectionActivityWithoutTracks';
import type { VersionMetadata } from './VersionMetadata';
import {
    VersionMetadataFromJSON,
    VersionMetadataFromJSONTyped,
    VersionMetadataToJSON,
} from './VersionMetadata';

/**
 * 
 * @export
 * @interface CollectionLibraryResponse
 */
export interface CollectionLibraryResponse {
    /**
     * 
     * @type {number}
     * @memberof CollectionLibraryResponse
     */
    latestChainBlock: number;
    /**
     * 
     * @type {number}
     * @memberof CollectionLibraryResponse
     */
    latestIndexedBlock: number;
    /**
     * 
     * @type {number}
     * @memberof CollectionLibraryResponse
     */
    latestChainSlotPlays: number;
    /**
     * 
     * @type {number}
     * @memberof CollectionLibraryResponse
     */
    latestIndexedSlotPlays: number;
    /**
     * 
     * @type {string}
     * @memberof CollectionLibraryResponse
     */
    signature: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionLibraryResponse
     */
    timestamp: string;
    /**
     * 
     * @type {VersionMetadata}
     * @memberof CollectionLibraryResponse
     */
    version: VersionMetadata;
    /**
     * 
     * @type {Array<CollectionActivityWithoutTracks>}
     * @memberof CollectionLibraryResponse
     */
    data?: Array<CollectionActivityWithoutTracks>;
}

/**
 * Check if a given object implements the CollectionLibraryResponse interface.
 */
export function instanceOfCollectionLibraryResponse(value: object): value is CollectionLibraryResponse {
    let isInstance = true;
    isInstance = isInstance && "latestChainBlock" in value && value["latestChainBlock"] !== undefined;
    isInstance = isInstance && "latestIndexedBlock" in value && value["latestIndexedBlock"] !== undefined;
    isInstance = isInstance && "latestChainSlotPlays" in value && value["latestChainSlotPlays"] !== undefined;
    isInstance = isInstance && "latestIndexedSlotPlays" in value && value["latestIndexedSlotPlays"] !== undefined;
    isInstance = isInstance && "signature" in value && value["signature"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "version" in value && value["version"] !== undefined;

    return isInstance;
}

export function CollectionLibraryResponseFromJSON(json: any): CollectionLibraryResponse {
    return CollectionLibraryResponseFromJSONTyped(json, false);
}

export function CollectionLibraryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CollectionLibraryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'latestChainBlock': json['latest_chain_block'],
        'latestIndexedBlock': json['latest_indexed_block'],
        'latestChainSlotPlays': json['latest_chain_slot_plays'],
        'latestIndexedSlotPlays': json['latest_indexed_slot_plays'],
        'signature': json['signature'],
        'timestamp': json['timestamp'],
        'version': VersionMetadataFromJSON(json['version']),
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(CollectionActivityWithoutTracksFromJSON)),
    };
}

export function CollectionLibraryResponseToJSON(value?: CollectionLibraryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'latest_chain_block': value.latestChainBlock,
        'latest_indexed_block': value.latestIndexedBlock,
        'latest_chain_slot_plays': value.latestChainSlotPlays,
        'latest_indexed_slot_plays': value.latestIndexedSlotPlays,
        'signature': value.signature,
        'timestamp': value.timestamp,
        'version': VersionMetadataToJSON(value.version),
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(CollectionActivityWithoutTracksToJSON)),
    };
}

